<template>
  <div>
    <v-stepper
      v-model="tabs"
      style="background-color: transparent"
      tile
      elevation="0"
    >
      <v-stepper-header v-show="false">
        <v-stepper-step step="1"> 1 </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2"> 2 </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content step="1">
          <div class="pt-9">
            <v-row no-gutters align="center" justify="center">
              <v-col class="text-left" cols="12" sm="12" md="8">
                <v-form ref="formRegistry" lazy-validation>
                  <div class="d-flex align-center">
                    <div>
                      <router-link to="/Login" style="text-decoration: none">
                        <v-tooltip
                          right
                          content-class="arrow tooltip-right"
                          color="black"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon>
                              <v-icon large color="accent"
                                >icon-alertadis-angle-left-b</v-icon
                              >
                            </v-btn>
                          </template>
                          <span class="tooltip-text">Voltar para o login</span>
                        </v-tooltip>
                      </router-link>
                    </div>
                    <div class="pl-2">
                      <span
                        :class="
                          $vuetify.breakpoint.smAndDown
                            ? 'title-style-mobile'
                            : 'title-style-tablet'
                        "
                        >Esqueci a senha</span
                      >
                    </div>
                  </div>
                  <p
                    :class="
                      $vuetify.breakpoint.smAndDown
                        ? 'subtitle-style-mobile'
                        : 'subtitle-style-tablet'
                    "
                  >
                    Informe e-mail ou a matrícula cadastrada para recuperar a
                    sua senha.
                  </p>

                  <div class="pt-4 form-input-group">
                    <v-text-field
                      class="text-field"
                      id="email"
                      color="accent lighten-1"
                      background-color="trasnparent"
                      v-model="email"
                      :rules="[loginFieldRules]"
                      prepend-inner-icon="icon-alertadis-user-circle"
                      :append-icon="emailRules === true ? 'icon-alertadis-check' : ''"
                      outlined
                      required
                      placeholder="Informe seu e-mail ou matrícula"
                    />
                    <label for="email">E-mail ou matrícula</label>
                  </div>

                  <v-row no-gutters align="center" class="pt-9">
                    <v-col class="d-flex align-center">
                      <v-btn
                        class="btn-form"
                        color="accent lighten-1"
                        height="50"
                        width="169"
                        large
                        :loading="loading"
                        @click="registryValidate"
                      >
                        <span>Recuperar a senha</span>
                      </v-btn>
                    </v-col>
                    <v-btn icon>
                      <i class="uil uil-airplay"></i>
                    </v-btn>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </div>
        </v-stepper-content>
        <v-stepper-content step="2">
          <div class="pt-9">
            <v-row no-gutters align="center" justify="center">
              <v-col class="text-left" cols="12" sm="12" md="8">
                <v-form ref="formNewPassword" lazy-validation>
                  <div class="d-flex align-center">
                    <div>
                      <router-link to="/Login" style="text-decoration: none">
                        <v-tooltip
                          right
                          content-class="arrow tooltip-right"
                          color="black"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon>
                              <v-icon large color="accent"
                                >icon-alertadis-angle-left-b</v-icon
                              >
                            </v-btn>
                          </template>
                          <span class="tooltip-text">Voltar para o login</span>
                        </v-tooltip>
                      </router-link>
                    </div>
                    <div class="pl-2">
                      <span
                        :class="
                          $vuetify.breakpoint.smAndDown
                            ? 'title-style-mobile'
                            : 'title-style-tablet'
                        "
                        >Recuperar a senha</span
                      >
                    </div>
                  </div>
                  <p
                    :class="
                      $vuetify.breakpoint.smAndDown
                        ? 'subtitle-style-mobile'
                        : 'subtitle-style-tablet'
                    "
                  >
                    Informe o token para definir uma nova senha.
                  </p>

                  <div class="py-2 my-2 success-alert">
                    <div class="d-flex">
                      <div class="ml-2 d-flex align-start">
                        <v-icon color="success darken-1"
                          >icon-alertadis-check-circle</v-icon
                        >
                      </div>
                      <div class="pl-2 info-alert-text d-flex flex-column">
                        <div>Confira seu e-mail</div>
                        <div v-if="email.length == 7">
                          Insira o código de 6 digitos enviado para o email cadastrado com a matrícula {{ email }}
                        </div>
                        <div v-if="email.length != 7">
                          Insira o código de 6 digitos enviado para {{ email }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="pt-4 form-input-group">
                    <v-text-field
                      class="text-field"
                      id="token"
                      color="accent lighten-1"
                      background-color="trasnparent"
                      v-model="token"
                      :rules="[tokenRules]"
                      prepend-inner-icon="icon-alertadis-user-circle"
                      :append-icon="tokenRules === true ? 'icon-alertadis-check' : ''"
                      outlined
                      required
                      placeholder="Informe seu token"
                    />
                    <label for="token">Token</label>
                  </div>

                  <div class="pt-2 form-input-group">
                    <v-text-field
                      class="text-field"
                      id="password"
                      color="accent lighten-1"
                      background-color="trasnparent"
                      v-model="password"
                      :rules="[passwordRules]"
                      outlined
                      required
                      prepend-inner-icon="icon-alertadis-padlock"
                      :append-icon="passwordRules === true ? 'icon-alertadis-check' : ''"
                      :type="showPassword ? 'text' : 'password'"
                      placeholder="Informe a senha"
                    />
                    <label for="password">Nova Senha</label>
                  </div>
                  <v-checkbox
                    class="mt-1 check-form"
                    color="accent lighten-1"
                    v-model="showPassword"
                    label="Mostrar a nova senha"
                  />

                  <div class="ml-3 my-3">
                    <v-row>
                      <v-icon
                        :color="leastEightCharacters ? 'success' : 'primary'"
                        >icon-alertadis-check</v-icon
                      >
                      <span class="ml-1 text-rules"
                        >Pelo menos 8 caracteres</span
                      >
                    </v-row>
                    <v-row class="mt-5">
                      <v-icon :color="leastOneUpperCase ? 'success' : 'primary'"
                        >icon-alertadis-check</v-icon
                      >
                      <span class="ml-1 text-rules"
                        >Pelo menos 1 letra maiúscula</span
                      >
                    </v-row>
                    <v-row class="mt-5">
                      <v-icon :color="leastOneNumber ? 'success' : 'primary'"
                        >icon-alertadis-check</v-icon
                      >
                      <span class="ml-1 text-rules">Pelo menos 1 número</span>
                    </v-row>
                    <v-row class="mt-5">
                      <v-icon
                        :color="leastOneSpecialChar ? 'success' : 'primary'"
                        >icon-alertadis-check</v-icon
                      >
                      <span class="ml-1 text-rules"
                        >Pelo menos 1 caractere especial</span
                      >
                    </v-row>
                  </div>

                  <v-row no-gutters align="center" class="pt-9">
                    <v-col
                      :class="
                        $vuetify.breakpoint.smAndDown
                          ? 'd-flex flex-column'
                          : 'd-flex align-center'
                      "
                    >
                      <v-btn
                        class="btn-form"
                        color="accent lighten-1"
                        height="50"
                        width="263"
                        large
                        :loading="loading"
                        @click="confirmAndLogIn"
                      >
                        <span>Confirmar e acessar o AlertaDIS</span>
                      </v-btn>
                      <a
                        :class="
                          $vuetify.breakpoint.smAndDown
                            ? 'label-resend-token pl-4 pt-4'
                            : 'label-resend-token pl-4'
                        "
                        @click="resendToken"
                        >Reenviar token</a
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-col>
            </v-row>
          </div>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import { snackbar } from "@/core/controller/snackbar_controller";
export default {
  name: "ForgotPassword",
  data: () => ({
    email: "",
    password: undefined,
    showPassword: false,
    checkbox: false,
    loading: false,
    alert: false,
    messageError: "",
    passwordRulesValue: false,
    loginFieldRules: null,
    tabs: 1,
    token: null,
  }),
  created() {
    this.password = "";
    this.loginFieldRules = this.emailRules;
  },
  mounted() {
    window.addEventListener("keydown", this.handleEnter);
  },
  destroyed() {
    window.removeEventListener("keydown", this.handleEnter);
  },
  watch: {
    password(value) {
      this.passwordRules = this.validatePassword(value);
    },
    email() {
      if (!this.email.includes("@")) {
        this.loginFieldRules = this.registryRules;
      } else {
        this.loginFieldRules = this.emailRules;
      }
    },
  },
  computed: {
    emailRules() {
      if (!this.email) {
        return "Você precisa informar o e-mail ou a matrícula para recuperar a senha.";
      }

      if (/.+@.+\..+/.test(this.email) == false) {
        return "Este e-mail é inválido. Informe o seu e-mail no formato exemplo@exemplo.com.";
      }

      if (
        /^\w+([-+.']\w+)*@?(simepar.br|copel.com|jointecnologia.com.br)$/.test(
          this.email
        ) == false
      ) {
        return "O e-mail deve pertencer ao Simepar ou a Copel.";
      }
      return true;
    },
    registryRules() {
      if (/^[A-Z]{1}[0-9]{6}$/.test(this.email) == false) {
        return "E-mail ou matrícula inválido.";
      }
      return true;
    },
    tokenRules() {
      if (!this.token) {
        return "Você precisa informar o seu token";
      }
      return true;
    },
    passwordRules: {
      set(value) {
        if (value) {
          this.passwordRulesValue = value;
          return;
        }

        this.passwordRulesValue = true;
      },
      get() {
        return this.passwordRulesValue;
      },
    },
    /*     passwordRules() {
      if (!this.password) {
        return "Você precisa inserir sua nova senha.";
      }
      if (
        this.password.length < 8 ||
        !/[A-Z]/.test(this.password) ||
        !/[0-9]/.test(this.password) ||
        !/(?=.*[!@#$%^&*])/.test(this.password)
      ) {
        return "Verifique os requisitos abaixo para criar a nova senha.";
      }
      return true;
    }, */

    leastEightCharacters() {
      return this.password.length >= 8;
    },
    leastOneUpperCase() {
      return /[A-Z]/.test(this.password);
    },
    leastOneNumber() {
      return /[0-9]/.test(this.password);
    },
    leastOneSpecialChar() {
      return /(?=.*[!@#$%^&*])/.test(this.password);
    },
  },
  methods: {
    handleEnter(e) {
      if (e.key === "Enter") {
        this.recoverPassword();
      }
    },
    validatePassword(value) {
      !value
        ? "Verifique os requisitos abaixo para criar a nova senha."
        : undefined;

      if (!value) {
        return "Verifique os requisitos abaixo para criar a nova senha.";
      }

      if (
        value.length < 8 ||
        !/[A-Z]/.test(value) ||
        !/[0-9]/.test(value) ||
        !/(?=.*[!@#$%^&*])/.test(value)
      ) {
        return "Verifique os requisitos abaixo para criar a nova senha.";
      }

      if (value == "") return true;
    },
    async registryValidate() {
      if (this.$refs.formRegistry.validate()) {
        this.loading = true;
        try {
          await this.$store.dispatch("forgotPassword", {
            login: this.email,
          });
          this.tabs = 2;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      }
    },
    async resendToken() {
      try {
        await this.$store.dispatch("forgotPassword", {
          login: this.email,
        });
        snackbar.show({
          type: "success",
          title: "Token enviado com sucesso",
          timeout: 3000,
        });
      } catch (error) {
        console.log(error);
      }
    },

    async confirmAndLogIn() {
      if (this.$refs.formNewPassword.validate()) {
        this.loading = true;
        try {
          await this.$store.dispatch("resetPassword", {
            login: this.email,
            password: this.password,
            token: this.token,
          });
          snackbar.show({
            type: "success",
            title: "Senha alterada com sucesso",
            timeout: 3000,
          });
          await this.$store.dispatch("signIn", {
            email: this.email,
            password: this.password,
          });
        } catch (error) {
          snackbar.show({
            type: "error",
            title: "Erro",
            message: error.response.data.message,
            timeout: 5000,
          });
        } finally {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style scoped>
label {
  order: -1;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}

.text-field {
  border-radius: 8px;
}

.btn-form {
  text-transform: none;
  border-radius: 8px;
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.check-form {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.v-input:focus-within + label {
  color: var(--v-accent-lighten1) !important;
}

.form-input-group {
  display: flex;
  flex-direction: column;
}

.form-input-group /deep/ .v-input__icon--append .v-icon {
  color: var(--v-success-base) !important;
}

.title-style-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.25px;
  color: var(--v-primary-base);
}

.title-style-tablet {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 45px;
  letter-spacing: 0.25px;
  color: var(--v-primary-base);
}

.subtitle-style-mobile {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}

.subtitle-style-tablet {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-darken2);
}

.label-resend-token {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-accent-lighten1) !important;
}

.tooltip-right::before {
  content: " ";
  position: absolute;
  top: 50%;
  right: 100%; /* To the left of the tooltip */
  margin-top: -8px;
  border-width: 8px;
  border-style: solid;
  border-top: solid 8px transparent;
  border-bottom: solid 8px transparent;
  border-left: solid 8px transparent;
}

.tooltip-right.arrow::before {
  border-right: solid 8px black !important;
}

.tooltip-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.4px;
}

.success-alert {
  border-radius: 8px;
  color: var(--v-success-darken1);
  background-color: var(--v-success-lighten1) !important;
}

.success-alert-title {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}
.success-alert-text {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
}

.text-rules {
  font-family: "Manrope";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: 0.75px;
  color: var(--v-primary-base);
}
</style>